import React from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-tanque.png";
import { TextContainer, Title, Footer } from "./StartPageStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemLaundryStyles";
import { setPage } from "../../../../stores/LaundryStore/LaundryStore";
import { PAGES } from "../../../../stores/LaundryStore/LaundryStore.types";

const StartPage: React.FC = () => {
  const handleNext = () => {
    setPage(PAGES.CHOOSE_LAUNDRY_TYPE);
  };

  return (
    <GradientContainer onClick={handleNext}>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Title>ECONOMIZA</Title>
        <Subtitle>TEMPO | DINHEIRO</Subtitle>
      </TextContainer>
      <Footer>Toque na tela para iniciar atendimento...</Footer>
    </GradientContainer>
  );
};

export default StartPage;
